<div *ngIf="error">
  <app-modal isActive="true" zIndex="60" [isSmall]="true" (modalState)="closeModal.emit(true)">
    <p class="modal-card-title" modal-title>
      <em
        *ngIf="error.alertType"
        class="mdi mdi-check-circle mdi-16px has-text-primary"
        aria-hidden="true"
      ></em>

      <em
        *ngIf="!error.alertType"
        class="mdi mdi-alert-circle mdi-16px has-text-danger"
        aria-hidden="true"
      ></em>

      {{ (!!error.alertType ? 'shared.successful-operation' : 'errors.title') | translate }}
    </p>
    <div modal-content>
      {{
        ('errors.' + error.errorCode | translate) !== 'errors.' + error.errorCode
          ? ('errors.' + error.errorCode | translate)
          : error.message
      }}
      <br />
      {{ error.errorCode === 10 ? error.message : ' ' }}
    </div>
  </app-modal>
</div>
